import { render, staticRenderFns } from "./form-row-upload-single-document.vue?vue&type=template&id=56098dcf&scoped=true&"
import script from "./form-row-upload-single-document.vue?vue&type=script&lang=js&"
export * from "./form-row-upload-single-document.vue?vue&type=script&lang=js&"
import style0 from "./form-row-upload-single-document.vue?vue&type=style&index=0&id=56098dcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56098dcf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56098dcf')) {
      api.createRecord('56098dcf', component.options)
    } else {
      api.reload('56098dcf', component.options)
    }
    module.hot.accept("./form-row-upload-single-document.vue?vue&type=template&id=56098dcf&scoped=true&", function () {
      api.rerender('56098dcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/form-row-upload-single-document.vue"
export default component.exports